import ModalWrapperHOC from "../../HOCs/ModalWrapperHOC";
import ModalWrapper from "../ModalWrapper";
import { FormField, FormDataBase, ValidationsType } from "../types";
import { getFeatureFlags } from "../../../featureFlags";

export interface AddAssessmentResultFormData extends FormDataBase {
  participant: FormField;
  caseNumber: FormField;
  assessmentType: FormField;
  createdBy: FormField;
}

export interface ObligationAndParticipantDetailsType {
  first: string;
  last: string;
  createdBy: string;
}

class AddAssessmentResultModalWrapper extends ModalWrapper<
  AddAssessmentResultFormData
> {
  static formState = getAddEventModalStatic(null);
  componentDidMount() {
    const { updateObject: obligationAndParticipantDetails } = this.props;

    if (obligationAndParticipantDetails) {
      AddAssessmentResultModalWrapper.formState = getAddEventModalStatic(
        obligationAndParticipantDetails
      );
    } else {
      AddAssessmentResultModalWrapper.formState = getAddEventModalStatic(null);
    }
  }
}

function getAddEventModalStatic(
  obligationAndParticipantDetails:
    | ObligationAndParticipantDetailsType
    | null
    | undefined
) {
  return {
    modalFormData: {
      participant: {
        label: getFeatureFlags().clientDisplayTerm || "Client",
        value: obligationAndParticipantDetails
          ? `${obligationAndParticipantDetails.first} ${obligationAndParticipantDetails.last}`
          : "",
      },
      caseNumber: {
        label: "Case Number",
        value: "",
      },
      assessmentType: {
        label: "Assessment Type",
        value: "ORAS-PAT",
      },
      createdBy: {
        label: "Scored by",
        value: obligationAndParticipantDetails
          ? obligationAndParticipantDetails.createdBy
          : "",
      },
    } as AddAssessmentResultFormData,
    validations: {
      participant: {
        state: "valid",
        errors: [] as string[],
      },
      caseNumber: {
        state: "pristine",
        errors: [] as string[],
      },
      assessmentType: { state: "valid", errors: [] as string[] },
      createdBy: { state: "valid", errors: [] as string[] },
    } as ValidationsType,
    attemptedSubmission: false,
    secondPage: false,
    secondPageMessageWarning: false,
    showModal: false,
  };
}

export default ModalWrapperHOC(AddAssessmentResultModalWrapper);
